export const getSegmentsFromParams = segments => {
    if (typeof segments === 'string') {
        return segments.split(',');
    }
    return segments;
};
